<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between g-3">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Cash Vouchers</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} Cash Vouchers.</p>
                            </div>
                        </div><!-- .nk-block-head-content -->
                        <div class="nk-block-head-content" v-if="roleName=='Super Admin' || roleName=='Customer'">
                            <ul class="nk-block-tools g-3">
                                <li><a href="javascript:void(0)" v-on:click="openModel('Add')" class="btn btn-primary"><span>Generate Voucher</span></a></li>
                                
                            </ul>
                        </div>
                    </div><!-- .nk-block-between -->
                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                            <div class="card-inner">
                                <div class="card-title-group">
                                    <div class="card-title">
                                        <h5 class="title">All Cash Vouchers</h5>
                                    </div>
                                    <div class="card-tools me-n1">
                                        <ul class="btn-toolbar">
                                            <li>
                                                <a href="javascript:void(0)" class="btn btn-icon search-toggle toggle-search" data-target="search"><em class="icon ni ni-search"></em></a>
                                            </li><!-- li -->
                                            <li class="btn-toolbar-sep"></li><!-- li -->
                                            <li>
                                                <div class="dropdown">
                                                    <a href="javascript:void(0)" class="btn btn-trigger btn-icon dropdown-toggle" data-bs-toggle="dropdown">
                                                        <em class="icon ni ni-setting"></em>
                                                    </a>
                                                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-xs">
                                                        <ul class="link-check">
                                                            <li><span>Show</span></li>
                                                            <li class="active"><a href="javascript:void(0)">10</a></li>
                                                        </ul>
                                                        <ul class="link-check">
                                                            <li><span>Order</span></li>
                                                            <li v-bind:class="isDesc ? 'active' : ''"><a v-on:click="getPageSize(true)" href="javascript:void(0)">DESC</a></li>
                                                            <li v-bind:class="!isDesc ? 'active' : ''"><a v-on:click="getPageSize(false)" href="javascript:void(0)">ASC</a></li>
                                                        </ul>
                                                    </div>
                                                </div><!-- .dropdown -->
                                            </li><!-- li -->
                                        </ul><!-- .btn-toolbar -->
                                    </div><!-- card-tools -->
                                    <div class="card-search search-wrap" data-search="search">
                                        <div class="search-content">
                                            <a href="javascript:void(0)" class="search-back btn btn-icon toggle-search" data-target="search"><em class="icon ni ni-arrow-left"></em></a>
                                            <input v-model="search" type="text" class="form-control form-control-sm border-transparent form-focus-none" placeholder="search by Bank Name">
                                            <button class="search-submit btn btn-icon"><em class="icon ni ni-search"></em></button>
                                        </div>
                                    </div><!-- card-search -->
                                </div><!-- .card-title-group -->
                            </div><!-- .card-inner -->
                            <div class="card-inner p-0">
                                <table class="table table-tranx">
                                    <thead>
                                        <tr class="tb-tnx-head">
                                            <th class="tb-tnx-info">#</th>
                                            <th class="tb-tnx-info">
                                                Code
                                            </th>
                                            <th class="tb-tnx-info">
                                                Pin
                                            </th>
                                            <th class="tb-tnx-info">
                                                Date
                                            </th>
                                            <th class="tb-tnx-info" v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'">
                                                User
                                            </th>
                                            <th class="tb-tnx-info text-right">
                                                Voucher Amount
                                            </th>
                                            <th class="tb-tnx-info">
                                                Expired Date
                                            </th>
                                            <th class="tb-tnx-info">
                                                Status
                                            </th>
                                            <th class="tb-tnx-action">
                                                <span>&nbsp;</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(details, index) in userList" v-bind:key="details.id" class="tb-tnx-item">
                                            <td class="tb-tnx-info" v-if="currentPage === 1">
                                                {{index+1}}
                                            </td>
                                            <td class="tb-tnx-info" v-else>
                                                {{((currentPage*10)-10) +(index+1)}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.code}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.voucherNo}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.createdDate}}
                                            </td>
                                            <td class="tb-tnx-info text-right" v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'">
                                                {{details.userName}}
                                            </td>
                                            <td class="tb-tnx-info text-right">
                                                {{AmountFormat(details.amount)}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.usedDate}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                <span v-if="!details.status" class="badge badge-dot bg-success">Open</span>
                                                <span v-else class="badge badge-dot bg-danger">Expired</span>
                                            </td>
                                            <td class="tb-tnx-action">
                                                <div class="dropdown" v-if="details.approval==2">
                                                    <a class="text-soft dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                                                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-xs">
                                                        <ul class="link-list-plain">
                                                            <li><a v-on:click="EditInfo(details, 'Approved', 'Edit')" href="javascript:void(0)">Approved</a></li>
                                                            <li><a v-on:click="EditInfo(details, 'Rejected', 'Edit')" href="javascript:void(0)">Rejected</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><!-- .card-inner -->
                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div><!-- .card-inner -->
                        </div><!-- .card-inner-group -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <cash-voucher-modal :userDetail="userDetail" :show="show" v-if="show" @close="IsSave" />
    </div>

</template>
<script>
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    export default {
        name: 'WithdrawalList',
        components: {
            Loading
        },
        data: function () {
            return {
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: true,

                loading: false,
                show: false,
                userList: [],
                userDetail: '',
                roleName: '',
                approval: '',

            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {

            IsSave: function () {
                this.show = false;
                this.getPage();
            },

            AmountFormat: function (amount) {
                return parseFloat(amount).toFixed(4).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },

            AddSignup: function () {
                this.$router.push('/AddPackagePrice')
            },

            getPageSize: function (isDesc) {
                this.isDesc = isDesc;
                this.getPage();
            },

            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Bonus/CashVoucherList?searchTerm=' + search + '&pageNumber=' + currentPage + '&isDesc=' + this.isDesc;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                        icon: 'error',
                        type: 'error',
                        title: 'Error',
                        text: "Something Went Wrong",
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                    });
                }).finally(() => root.loading = false);
            },


            openModel: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Bonus/WithdrawalNetAmountDetail?Id', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userDetail = response.data;
                        root.show = true;
                    }
                });
            },


        },
        created: function () {
        },
        mounted: function () {
            this.GetData(this.search, 1);

            this.roleName = localStorage.getItem('RoleName');
        },
    }
</script>